const allowedEnvironments = new Set(['localhost', 'development', 'staging', 'production']);

const configuredEnvironment = import.meta.env.VITE_DEFAULT_ENVIRONMENT;
const environmentUrls = {
  localhost: import.meta.env.VITE_API_URL_LOCAL,
  development: import.meta.env.VITE_API_URL_DEV,
  staging: import.meta.env.VITE_API_URL_STAGING,
  production: import.meta.env.VITE_API_URL_PROD,
};

export const FOLD_ENVIRONMENT = configuredEnvironment || (import.meta.env.DEV ? 'localhost' : null);
export const API_BASE_URL = environmentUrls[FOLD_ENVIRONMENT] ||
  (FOLD_ENVIRONMENT === 'localhost' ? 'http://localhost:3001/api' : null);

if (!FOLD_ENVIRONMENT || !allowedEnvironments.has(FOLD_ENVIRONMENT)) {
  throw new Error('VITE_DEFAULT_ENVIRONMENT must be localhost, development, staging, or production');
}

if (!API_BASE_URL) {
  throw new Error(`The API URL for ${FOLD_ENVIRONMENT} is required for The Fold production build`);
}
